import { createSlice, createAction } from "@reduxjs/toolkit";
import api from "./api";

export const logout = createAction("logout");

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null,
    token: localStorage.getItem("token")
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(logout, state => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        state.user = null;
        state.token = null;
      })
      .addMatcher(
        api.endpoints.authenticate.matchFulfilled,
        (state, { payload }) => {
          const { accessToken, ...data } = payload;
          let user;
          if (data.user) {
            user = { ...data.user };
          } else {
            user = { ...data };
          }
          state.token = accessToken;
          if (!user.profilePic) {
            user.profilePic = false;
          }
          user.fullName = `${user.firstName} ${user.lastName}`;
          state.user = user;
          localStorage.setItem("token", accessToken);
          localStorage.setItem("user", JSON.stringify(user));
        }
      );
  }
});

export default authSlice.reducer;
